import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import frenchMessages from "ra-language-french";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { raSupabaseFrenchMessages } from "ra-supabase-language-french";
import { classesMessages } from "../../classes/classesMessages";
import { champFamilyMessages } from "../../companies/champFamilyMessages";
import { programsMessages } from "../../programs/programsMessages";
import { champDomainMessages } from "./champDomainMessages";
import { champMessages } from "./champMessages";
import { englishCrmMessages } from "./englishCrmMessages";
import { frenchCrmMessages } from "./frenchCrmMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const raSupabaseFrenchMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Consultez vos emails pour trouver le message de reinitialisation du mot de passe.",
    },
  },
};

const upstreamEnglishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

// Labels for the screens and fields CHAMP adds (no upstream equivalent).
const champAdditions = mergeTranslations(
  champDomainMessages,
  champFamilyMessages,
  classesMessages,
  programsMessages,
);

// CHAMP wording on top of upstream: Families, People, Enrollments, Staff.
const englishCatalog = mergeTranslations(
  upstreamEnglishCatalog,
  champMessages,
  champAdditions,
);

const frenchCatalog = mergeTranslations(
  englishCatalog,
  frenchMessages,
  raSupabaseFrenchMessages,
  raSupabaseFrenchMessagesOverride,
  frenchCrmMessages,
);

export const getInitialLocale = (): "en" | "fr" => {
  if (typeof navigator === "undefined") {
    return "en";
  }

  const browserLocale = navigator.languages?.[0] ?? navigator.language;
  if (browserLocale?.toLowerCase().startsWith("fr")) {
    return "fr";
  }

  return "en";
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === "fr") {
      return frenchCatalog;
    }
    return englishCatalog;
  },
  getInitialLocale(),
  [
    { locale: "en", name: "English" },
    { locale: "fr", name: "Français" },
  ],
  { allowMissing: true },
);

// Tests keep upstream wording so upstream tests merge cleanly; the CHAMP
// re-wording is covered once in i18nProvider.test.ts.
export const testI18nProvider = polyglotI18nProvider(
  () => mergeTranslations(upstreamEnglishCatalog, champAdditions),
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
